import React from 'react'
function Certificate() {
return (
    <div>
            
    </div>
)
}
export default Certificate;
